import { createTheme, responsiveFontSizes, type Theme } from '@mui/material/styles';
import { baseRadius } from '@/tokens/radius';
import { spacingUnit } from '@/tokens/spacing';
import { darkPalette, lightPalette } from './palette';
import { typography } from './typography';
import { components } from './components';

const baseOptions = {
  spacing: spacingUnit,
  shape: { borderRadius: baseRadius },
  typography,
  components,
} as const;

/** Dark theme - the primary, Figma-accurate theme. */
export const darkTheme: Theme = responsiveFontSizes(
  createTheme({ ...baseOptions, palette: darkPalette }),
);

/** Light theme - derived for completeness. */
export const lightTheme: Theme = responsiveFontSizes(
  createTheme({ ...baseOptions, palette: lightPalette }),
);

/** Default export is the dark theme (dark-first design system). */
export const theme = darkTheme;

export const themes = { dark: darkTheme, light: lightTheme } as const;
export type ThemeMode = keyof typeof themes;

export { darkPalette, lightPalette, severityPalette } from './palette';
export { typography } from './typography';
export { components } from './components';

/**
 * Theming surface. Consuming apps get `ThemeProvider`, `CssBaseline`, `useTheme`
 * and the theme types from this package - there is no need to import them from
 * MUI directly.
 */
export * from './provider';
export { useTheme } from '@mui/material/styles';
export type { Theme, SxProps } from '@mui/material/styles';
